import { createClient } from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database
const supabase = createClient('https://evvrvvydpfmzyhhquvkf.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV2dnJ2dnlkcGZtenloaHF1dmtmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODY1NTM5OTYsImV4cCI6MjAwMjEyOTk5Nn0.VujXaow13DorY6UB8zdS552cl3JpF2NMejjP7Jqa-ak')

export default supabase